/* Live refresh: pages call useLive(load) and re-load when (a) this tab saved something, (b) the server pulse says the books / QuickBooks changed,
   (c) the tab comes back into view, or (d) an optional timer fires. No more pressing refresh. */
import { useEffect, useRef } from "react";

export const LIVE_EVENT = "tp:live";
export const pingLive = (detail = {}) => window.dispatchEvent(new CustomEvent(LIVE_EVENT, { detail }));

export const useLive = (fn, { every = 0, enabled = true } = {}) => {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!enabled) return undefined;
    let last = 0, lastSelf = 0;
    const run = (detail) => {
      const now = Date.now();
      if (now - last < 800) return;
      if (detail?.source === "self" && lastSelf && now - lastSelf < 3000) return;   // a reload that itself writes must not loop
      last = now; lastSelf = detail?.source === "self" ? now : 0;
      try { ref.current(detail); } catch { /* page handles its own errors */ }
    };
    const onLive = (e) => run(e.detail || {});
    const onSaved = () => run({ source: "self" });
    const onVis = () => { if (document.visibilityState === "visible") run({ source: "focus" }); };
    window.addEventListener(LIVE_EVENT, onLive);
    window.addEventListener("tp:tx-saved", onSaved);
    document.addEventListener("visibilitychange", onVis);
    const id = every > 0 ? setInterval(() => { if (document.visibilityState === "visible") run({ source: "timer" }); }, every) : null;
    return () => { window.removeEventListener(LIVE_EVENT, onLive); window.removeEventListener("tp:tx-saved", onSaved); document.removeEventListener("visibilitychange", onVis); if (id) clearInterval(id); };
  }, [every, enabled]);
};
